// Importar todas as funções necessárias
import { getAvailableTimeSlots as getAvailableTimeSlotsFirebase } from './appointments';
import { createAppointment as createAppointmentFirebase } from './appointments';
import { getAllProfessionals } from './appointments';
import { getSalonConfig as getSalonConfigFirebase } from './appointments';
import { getCategories as getCategoriesFirebase } from './salon';

// Configuração básica do Firebase
export { db, auth, firebaseApp, formatTimestamp, formatDocument } from './firebase';

// Exportações de autenticação
export {
  loginWithEmail,
  registerWithEmail,
  logout,
  resetPassword
} from './auth';

// Exportações de salões
export {
  getSalonConfig,
  updateSalonConfig,
  createExampleSalon,
  getCategories,
  addCategory,
  updateCategory,
  deleteCategory
} from './salon';

// Exportações de agendamentos
export {
  getAppointments,
  createAppointment,
  confirmAppointment,
  cancelAppointment,
  markAppointmentMessageSent,
  getPendingConfirmations,
  updateAppointment,
  deleteAppointment
} from './appointments';

// Exportações de profissionais
export {
  getProfessionals,
  getProfessional,
  addProfessional,
  updateProfessional,
  deleteProfessional,
  getProfessionalAvailability,
  updateProfessionalAvailability
} from './professionals';

// Exportações de serviços
export {
  getServices,
  getService,
  addService,
  updateService,
  deleteService,
  updateServicesOrder
} from './services';

// Exportações de associações profissionais-serviços
export {
  getProfessionalServiceAssociation,
  getAllProfessionalServiceAssociations,
  getProfessionalServices,
  getServiceProfessionals,
  updateProfessionalServiceAssociation,
  deleteProfessionalServiceAssociation,
  batchUpdateProfessionalServiceAssociations
} from './professionalServices';

// Exportações de clientes
export * from './clients';

// Exportações de análise de retenção
export {
  getSectorRetentionMetrics,
  getBusinessRetentionMetrics
} from './clientRetention';

// Exportações de convites
export {
  createUserInvitation,
  getUserInvitationByToken,
  getUserInvitationByEmail,
  getPendingInvitations,
  acceptInvitation,
  cancelInvitation,
  resendInvitation
} from './invitations';

// Exportações de utilidades do Firebase
export {
  generateAssociationId,
  updateCounter,
  validateEntityExists,
  logOperation
} from './utils/firebaseUtils';

// Exportação de funções de gerenciamento de usuários
export {
  getUserRoles,
  isSuperAdmin,
  getUserSalons,
  checkUserPermission,
  addUserToSalon,
  removeUserFromSalon,
  updateUserPermissions,
  setSuperAdmin,
  canUserManageUsers
} from './userRoles';

// Exportar uma função auxiliar para obter slots de horário disponíveis
export const fetchAvailableTimeSlots = (salonId, date, professionalId, serviceIds) => {
  return getAvailableTimeSlotsFirebase(salonId, date, professionalId, serviceIds);
};

// Categorias - implementação personalizada
export const getCategoriesFromFirebase = (salonId) => {
  return getCategoriesFirebase(salonId);
};

// Configuração do salão - implementação personalizada
export const getSalonConfigFromFirebase = (salonId) => {
  return getSalonConfigFirebase(salonId);
};

// Profissionais - implementação personalizada
export const getAllSalonProfessionals = (salonId) => {
  return getAllProfessionals(salonId);
};

// Criar agendamento - implementação personalizada
export const createNewAppointment = (salonId, appointmentData) => {
  return createAppointmentFirebase(salonId, appointmentData);
}; 